export class Page<T> {
  public results: Array<T>;
  public requestedItemsPerPage: number;
  public offset: number;
  public total: number;

  public getTotalPages(): number {
    return Math.ceil(this.total / this.requestedItemsPerPage);
  }

  public getCurrentPage(): number {
    return this.offset / this.requestedItemsPerPage + 1;
  }
}
